import React, { useCallback, useEffect, useRef } from 'react';
import { IForm } from 'types/widgets';

interface IPropTypes {
  desc: IForm;
}

const Form: React.FC<IPropTypes> = ({ desc }) => {
  const { id, dataSources } = desc;

  const ref = useRef<HTMLFormElement>(null);

  const onSubmit = useCallback(
    (event: Event) => {
      event.preventDefault();
      const elements = (event.target as HTMLFormElement)?.elements;

      dataSources.forEach((source) => {
        const element = elements?.namedItem(source.id) as HTMLInputElement;
        const value = element?.value ?? 'not_found';

        ref.current?.dispatchEvent(
          new CustomEvent('promo-click', {
            bubbles: true,
            detail: {
              origin: {
                target: {
                  id: source.label || source.id,
                  _type: 'range_widget_auto',
                  slide: desc.parent,
                },
                caption: value,
              },
            },
          }),
        );
      });
    },
    [dataSources, desc.parent],
  );

  useEffect(() => {
    const formRef = ref.current;
    formRef?.addEventListener('form-submit', onSubmit);

    return () => {
      formRef?.removeEventListener('form-submit', onSubmit);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <form id={id} ref={ref} style={{ display: 'none' }} />;
};

export default React.memo(Form);
